var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('ul',{staticStyle:{"list-style":"circle"}},_vm._l((_vm.results),function(product){return _c('li',[_vm._v(_vm._s(product.brandName || '')+", "+_vm._s(product.collectionName || '')+", "+_vm._s(product.name || ''))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f5311ed","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CRUDs/ProductRow.vue
// module id = null
// module chunks = 